import { Link } from "@tanstack/react-router";
import { ArrowLeft, FileX2 } from "lucide-react";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  EmptyState,
  PAGE_COLUMN,
  TOUCH_BUTTON,
} from "@/components/ui/redesign/page";
import { cn } from "@/lib/utils";

// Shown instead of the visit when the server says it does not exist for this
// account (deleted, another account's, or a malformed link): there is nothing
// to retry, so the only useful action is going back to the list.
export const VisitUnavailable = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className={PAGE_COLUMN}>
      <EmptyState
        className="py-16"
        description={t("visit.unavailableState.description")}
        icon={FileX2}
        testId="visit-unavailable"
        title={t("visit.unavailableState.title")}
      >
        <Button asChild className={cn(TOUCH_BUTTON, "gap-1.5")}>
          <Link to="/visits">
            <ArrowLeft aria-hidden />
            {t("visit.unavailableState.backToVisits")}
          </Link>
        </Button>
      </EmptyState>
    </div>
  );
};
